import React, { useState, useEffect } from 'react';
import TopNavbar from '.';
import useScrollDirection from 'modules/locals/hooks/useScrollDirection';

const SCROLL_TOP_BEFORE_TRANSITION = 96; // # of pixels before the background transitions from transparent to white

function TransparentTopNavbar({ showSearch, subNavbar, nonFixedNavbar, renderNavbarLinks }) {
  const [transparent, toggleTransparent] = useState(true);
  const { y } = useScrollDirection();

  useEffect(() => {
    if (y > SCROLL_TOP_BEFORE_TRANSITION && transparent) {
      toggleTransparent(false);
    }
    if (y <= SCROLL_TOP_BEFORE_TRANSITION && !transparent) {
      toggleTransparent(true);
    }
  }, [y, transparent]);

  return (
    <TopNavbar
      showSearch={showSearch}
      transparent={transparent}
      subNavbar={subNavbar}
      nonFixedNavbar={nonFixedNavbar}
      renderNavbarLinks={renderNavbarLinks}
    />
  );
}

export default TransparentTopNavbar;
